import React from 'react';
import PropTypes from 'prop-types';
/*
*  -------- IMPORTANT --------
*  If you change this, please browserify the following components:
*  - transactable
* */

class Modal extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      scrollPosition: null
    };

    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.renderHeader = this.renderHeader.bind(this);
    this.renderSubheader = this.renderSubheader.bind(this);
    this.renderBanner = this.renderBanner.bind(this);
  }

  componentDidMount () {
    const opts = {
      show: false,
      backdrop: 'static'
    };

    if (false === this.props.allowClickAway) {
      opts.backdrop = 'static';
    }

    // init modal, but don't open
    $('#modal-container').modal(opts);

    if (this.props.show) {
      // first call for modal, let's open it
      this.openModal();
    }

    // let's set the clickaway & close behavior to unmount component
    $('#modal-container').on('hidden.bs.modal', this.closeModal);

    // if a function, like analytic, needs to fire once Modal mounts, call it here
    if (this.props.didMountFunction) {
      this.props.didMountFunction();
    }

    const modalWidth = $('.modal-dialogue').width();
    const screenWidth = screen.width;
    const isFullScreen = modalWidth >= screenWidth || modalWidth !== 0;

    if (isFullScreen) {
      const scrollPosition = $(window).scrollTop();

      // save scroll position of document
      this.setState({
        scrollPosition
      });

      // scroll to bottom
      window.scrollTo(0, document.body.scrollHeight);
    }
  }

  componentWillReceiveProps (nextProps) {
    // if top level component says close the modal, then close the modal
    if (!nextProps.show) { return this.closeModal(); }
    // if modal needs to be opened again, let's open it
    if (nextProps.show) { return this.openModal(); }
  }

  componentWillUnmount () {
    $('#modal-container').off('hidden.bs.modal');
  }

  closeModal (event) {
    $('#modal-container').modal('hide');

    const { scrollPosition } = this.state;
    const modalWidth = $('.modal-dialog').width();
    const screenWidth = screen.width;
    const isFullScreen = modalWidth >= screenWidth || modalWidth !== 0;

    // scroll to position if available
    if (scrollPosition && isFullScreen) {
      window.scrollTo(0, scrollPosition);
    }

    if (this.props.closeBehavior) {
      this.props.closeBehavior(event);
    }
  }

  openModal () {
    $('#modal-container').modal();
  }

  renderHeader () {
    const modalType = this.props.modalType;

    switch (modalType) {
    case 'special':
      return <h2>{this.props.header}</h2>;
    case 'trans':
      return <h4>{this.props.header}</h4>;
    default:
      return <h3>{this.props.header}</h3>;
    }
  }

  renderSubheader () {
    switch (this.props.modalType) {
    case 'special':
      return <div className="form-modal">{this.props.subheader}</div>;
    default:
      return <p>{this.props.subheader}</p>;
    }
  }

  renderBanner () {
    const { text, type } = this.props.banner;
    const bannerClass = `text-center header-banner ${type}`;
    return (<div className={bannerClass}>{ text }</div>);
  }

  render () {
    let headerCloseIcon;
    let headerClass;
    let headerText = null;
    let subHeaderText = null;
    let banner = null;
    const { showBanner = true } = this.props;

    if (this.props.addCloseIcon) {
      headerCloseIcon = <span className="pull-right ico ico-sm icon-close-sidebar margin-lg-right" onClick={this.closeModal} />;
    }

    if (this.props.header) {
      headerText = this.renderHeader();
    }

    if (this.props.subheader) {
      subHeaderText = this.renderSubheader();
    }

    if (this.props.banner) {
      banner = this.renderBanner();
    }

    headerClass = 'modal-header text-center col-xs-12';

    return (
      <div id={this.props.modalID} className={`modal-dialogue ${this.props.modalSize} ${this.props.modalClass || ''}`} role="document">
        <div className="modal-content">
          <div className="modal-banner no-padding">
            {showBanner && banner}
            {headerCloseIcon}
          </div>
          {
            this.props.header || this.props.subheader ?
              <div className={headerClass} >
                {headerText}
                {subHeaderText}
              </div> : ''
          }
          <div id="modal-body" className="modal-body col-xs-12">
            {this.props.body}
          </div>
          {
            this.props.footer ?
              <div id="modal-footer" className="modal-footer col-xs-12">
                {this.props.footer}
              </div> : null
          }
        </div>
      </div>
    );
  }
}

Modal.propTypes = {
  addCloseIcon: PropTypes.bool.isRequired,
  show: PropTypes.bool.isRequired,
  modalID: PropTypes.string.isRequired,
  modalSize: PropTypes.oneOf(['sm-size', 'md-size', 'lg-size']).isRequired,
  modalType: PropTypes.oneOf(['special', 'standard', 'trans']),
  modalClass: PropTypes.string,
  header: PropTypes.string,
  subheader: PropTypes.oneOfType([
    PropTypes.string, PropTypes.object
  ]),
  banner: PropTypes.shape({
    type: PropTypes.string,
    text: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object
    ])
  }),
  body: PropTypes.oneOfType([
    PropTypes.string, PropTypes.object
  ]),
  footer: PropTypes.oneOfType([
    PropTypes.string, PropTypes.object
  ]),
  didMountFunction: PropTypes.func,
  closeBehavior: PropTypes.func,
  allowClickAway: PropTypes.bool
};

Modal.defaultProps = {
  show: false,
  header: null,
  subheader: null,
  banner: null,
  body: null,
  footer: null,
  modalType: 'standard',
  addCloseIcon: true,
  grayHeaderBg: false
};

export default { Modal };
